import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=6e95aeba&"
import script from "./Teaser.vue?vue&type=script&lang=ts&"
export * from "./Teaser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports